__turbopack_context__.v({
  "benefitItem": "SharedDetailModal-module__Gn8s2W__benefitItem",
  "benefitsList": "SharedDetailModal-module__Gn8s2W__benefitsList",
  "closeButton": "SharedDetailModal-module__Gn8s2W__closeButton",
  "descriptionText": "SharedDetailModal-module__Gn8s2W__descriptionText",
  "fallbackContent": "SharedDetailModal-module__Gn8s2W__fallbackContent",
  "footerWrapper": "SharedDetailModal-module__Gn8s2W__footerWrapper",
  "gradientFade": "SharedDetailModal-module__Gn8s2W__gradientFade",
  "headerSection": "SharedDetailModal-module__Gn8s2W__headerSection",
  "headerThumbnail": "SharedDetailModal-module__Gn8s2W__headerThumbnail",
  "headerTitle": "SharedDetailModal-module__Gn8s2W__headerTitle",
  "modalContainer": "SharedDetailModal-module__Gn8s2W__modalContainer",
  "modalContent": "SharedDetailModal-module__Gn8s2W__modalContent",
  "sectionImage": "SharedDetailModal-module__Gn8s2W__sectionImage",
  "sectionItem": "SharedDetailModal-module__Gn8s2W__sectionItem",
  "sectionText": "SharedDetailModal-module__Gn8s2W__sectionText",
  "sectionTitle": "SharedDetailModal-module__Gn8s2W__sectionTitle",
  "sectionsContainer": "SharedDetailModal-module__Gn8s2W__sectionsContainer",
  "stickyFooter": "SharedDetailModal-module__Gn8s2W__stickyFooter",
  "thumbnailPlaceholder": "SharedDetailModal-module__Gn8s2W__thumbnailPlaceholder",
});
